import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-gray-50">
      <div className="w-full max-w-xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
          <div className="p-8 md:p-12">
            <h1></h1>

            <h1></h1>
            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center mt-48">
              404 - Page Not Found
            </h1>

            <div className="bg-gray-50 rounded-lg p-8">
              <p className="text-gray-600 text-lg text-center leading-relaxed mb-8">
                The page you are looking for might have been removed, had its
                name changed, or is temporarily unavailable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
